var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseFillYellowIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 0C5.87695 0 0 5.87695 0 13.125C0 20.373 5.87695 26.25 13.125 26.25C20.373 26.25 26.25 20.373 26.25 13.125C26.25 5.87695 20.373 0 13.125 0ZM17.9707 18.1113L16.0371 18.1025L13.125 14.6309L10.2158 18.0996L8.2793 18.1084C8.15039 18.1084 8.04492 18.0059 8.04492 17.874C8.04492 17.8184 8.06543 17.7656 8.10059 17.7217L11.9121 13.1807L8.10059 8.64258C8.06518 8.59964 8.04554 8.54588 8.04492 8.49023C8.04492 8.36133 8.15039 8.25586 8.2793 8.25586L10.2158 8.26465L13.125 11.7363L16.0342 8.26758L17.9678 8.25879C18.0967 8.25879 18.2021 8.36133 18.2021 8.49316C18.2021 8.54883 18.1816 8.60156 18.1465 8.64551L14.3408 13.1836L18.1494 17.7246C18.1846 17.7686 18.2051 17.8213 18.2051 17.877C18.2051 18.0059 18.0996 18.1113 17.9707 18.1113Z",
    fill: "#FFC535"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFillYellowIc);
export default __webpack_public_path__ + "static/media/close_fill_yellow_ic.2eba6350e182eb80317bfcd322b43fa4.svg";
export { ForwardRef as ReactComponent };